import SimpleListItem from '../../models/simple-list-item';
var DtoConverter = /** @class */ (function () {
    function DtoConverter() {
    }
    DtoConverter.createList = function (targetClass, data) {
        if (data === void 0) { data = []; }
        var items = [];
        if (!(data instanceof Array) || 0 === data.length) {
            return items;
        }
        for (var key in data) {
            if (!data.hasOwnProperty(key)) {
                continue;
            }
            items.push(new targetClass(data[key]));
        }
        return items;
    };
    DtoConverter.createSimpleList = function (data, format, key) {
        if (key === void 0) { key = 'id'; }
        if (!data) {
            return [];
        }
        var result = [];
        data.forEach(function (item) {
            if (!item[key]) {
                return;
            }
            result.push(new SimpleListItem({
                value: item[key],
                label: format(item),
            }));
        });
        return result;
    };
    return DtoConverter;
}());
export default DtoConverter;
